import AGENT_STRUCT from "../agent";

const STRUCT = {
  ...AGENT_STRUCT,
};

export default STRUCT;
